import {
  REQUEST_APPOINTMENT_CANDIDATES,
  RECEIVE_APPOINTMENT_CANDIDATES,
  ERROR_APPOINTMENT_CANDIDATES,
  CLEAR_APPOINTMENT_CANDIDATES,
  SET_APPOINTMENT_CONTROL_NUMBER,
} from "typeConstants";
import { caseAppointment as initialState } from "../initialState.tsx";

// If working in dev, there's no FR calendars setup. Uncomment below and use in RECEIVE_APPOINTMENT_CANDIDATES to set candidates and endDate
// You'll need to update the dates

// const fakeData = {
//   "candidates": [
//       {
//           "fieldRepNumber": 19375,
//           "appointmentDateTime": "2024-06-28T08:00:00-04:00",
//           "distanceToCase": 22.43269974,
//           "rank": 1
//       },
//       {
//           "fieldRepNumber": 19375,
//           "appointmentDateTime": "2024-06-28T17:30:00-04:00",
//           "distanceToCase": 22.43269974,
//           "rank": 2
//       },
//       {
//           "fieldRepNumber": 19375,
//           "appointmentDateTime": "2024-07-01T08:00:00-04:00",
//           "distanceToCase": 22.43269974,
//           "rank": 3
//       },
//       {
//           "fieldRepNumber": 19375,
//           "appointmentDateTime": "2024-07-01T17:30:00-04:00",
//           "distanceToCase": 22.43269974,
//           "rank": 4
//       },
//       {
//           "fieldRepNumber": 19375,
//           "appointmentDateTime": "2024-07-02T08:00:00-04:00",
//           "distanceToCase": 22.43269974,
//           "rank": 5
//       }
//   ],
//   "dateRangeEnd": "2024-07-15T00:00:00-04:00"
// };

const caseAppointment = (state = initialState, action) => {
  switch (action.type) {
    case REQUEST_APPOINTMENT_CANDIDATES:
      return {
        ...state,
        fetchingCandidates: true,
        fetchingCandidatesError: false,
      };
    case RECEIVE_APPOINTMENT_CANDIDATES:
      return {
        ...state,
        fetchingCandidates: false,
        fetchingCandidatesError: false,
        candidates: action.payload?.candidates,
        endDate: action.payload?.dateRangeEnd,
        summary: action.payload?.summary,        
      };
    case ERROR_APPOINTMENT_CANDIDATES:
      return {
        ...state,
        fetchingCandidates: false,
        fetchingCandidatesError: true,
      };
    case CLEAR_APPOINTMENT_CANDIDATES:
      return {
        ...state,
        fetchingCandidates: false,
        fetchingCandidatesError: false,
        candidates: [],
        summary: [],
      };
    case SET_APPOINTMENT_CONTROL_NUMBER:
      return {
        ...state,
        controlNumber: action.payload,
      };
    default:
      return state;
  }
};

export default caseAppointment;